import React from "react";
import { AccessibilityUtils } from "gatsby-theme-jqi";
import Provider from "./src/wrappers/Provider";
import "./src/styles/index.scss";

export const onClientEntry = () => {
  document.documentElement.classList.add("js");
  AccessibilityUtils.init();
  return true;
};

export const onInitialClientRender = () => {
  AccessibilityUtils.disableTabbingWithinHiddenElementsOnInitialRender();
}

export const wrapPageElement = ({ element, props }) => {
  return (
    <Provider {...props}>{element}</Provider>
  );
};